import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assests/logo.jpg';
import foodImage from '../Assests/foods-home.webp';
import { CLIENT_NAME } from '../config/clientInfo';
import { useSettings } from '../Data/settings';
import './Home.css';

function Home() {
  const { settings } = useSettings();
  const addressLines = settings.address.split('\n').filter(line => line.trim());
    const role = Number(JSON.parse(localStorage.getItem('AutoParts') || 'null')?.role);
    return <main className="foods-home">
        <div className="foods-home-content">
            <img className="foods-home-logo" src={logo} alt={`${CLIENT_NAME} Restaurant logo`} draggable={false} />
            <div className="foods-home-eyebrow"><span /> WELCOME TO {CLIENT_NAME.toUpperCase()}</div>
            <h1>Freshly made.<br />Always <span>delicious.</span></h1>
            <p className="foods-home-description">Good food, served with a smile.<br />Make yourself at home.</p>
            <div className="foods-home-actions">
                {[1, 2].includes(role) && <Link className="foods-home-primary" to="/Billing">
                    Start billing <span aria-hidden="true">↗</span>
                </Link>}
                {/* Order status display is disabled for this client.
                <Link className="foods-home-secondary" to="/CustomerDashboard">View order status <span aria-hidden="true">→</span></Link>
                */}
            </div>
            <address className="foods-home-contact"><span>{addressLines.join(', ')}</span>
                <a href={`tel:${settings.telephone.replace(/\s/g, '')}`}>{settings.telephone}</a></address>
        </div>
        <div className="foods-home-photo"><img src={foodImage} alt="Fresh chicken fried rice with vegetables and lime juice" draggable={false} />
            <div className="foods-home-photo-caption"><span>FROM OUR KITCHEN</span><strong>Made fresh. Served with care.</strong></div>
        </div>
    </main>;
}

export default Home
